import { cn } from '@gto/ui/cn'

import type { AffiliateCouponTagSchema } from '@/domain/coupons'

import { getCouponTagColorClassName, getTagForegroundColor } from './coupon-tag-color'

type CouponTagPillProps = {
  tag: AffiliateCouponTagSchema
  compact?: boolean
}

export const CouponTagPill = ({ tag, compact = false }: CouponTagPillProps) => {
  const colorClassName = getCouponTagColorClassName(tag.color_hex)

  return (
    <span
      className={cn(
        'inline-flex max-w-32 items-center truncate rounded-sm font-semibold',
        compact ? 'px-1 py-0 text-xs leading-166' : 'px-1.5 py-0.5 text-sm leading-166',
        colorClassName,
      )}
      style={
        colorClassName === null
          ? {
              backgroundColor: tag.color_hex,
              color: getTagForegroundColor(tag.color_hex),
            }
          : undefined
      }
    >
      {tag.name}
    </span>
  )
}
